import backgroundCustomer from '../../media/backgroundCustomer.png';

export const backgroundImageStyle = {
    backgroundImage: `url(${backgroundCustomer})`,
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    minHeight: '100vh',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '50px', 
  };
  
  export const formContainerStyle = {
    backgroundColor: 'white',
    borderRadius: '8px',
    padding: '30px',
    width: '80%', 
    display: 'flex',
    flexDirection: 'row',
    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)', 
  };
  
  export const welcomeSectionStyle = {
    flex: '1',
    paddingRight: '30px',
  };
  
  export const formFieldsStyle = {
    flex: '1',
    display: 'flex',
    flexDirection: 'column',
    gap: '15px',
  };
  
  export const inputGroupStyle = {
    display: 'flex',
    flexDirection: 'column',
  };
  
  export const inputStyle = {
    padding: '10px',
    borderRadius: '4px',
    border: '1px solid #ccc',
    fontSize: '16px',
  };
  
  export const labelStyle = {
    marginBottom: '5px',
    fontWeight: 'bold',
  };
  
  export const checkboxContainerStyle = {
    display: 'flex',
    alignItems: 'center',
    marginBottom: '15px',
  };
  
  export const checkboxStyle = {
    marginRight: '5px',
  };
  
  export const submitButtonStyle = {
    backgroundColor: '#3498db', 
    color: 'white',
    padding: '12px 20px',
    borderRadius: '4px',
    border: 'none',
    fontSize: '18px',
    cursor: 'pointer',
  };